class DockerComposeFormController {
  /* @ngInject */
  constructor($async, EdgeTemplateService, Notifications) {
    Object.assign(this, { $async, EdgeTemplateService, Notifications });

    this.methodOptions = [
      { id: 'method_editor', icon: 'fa fa-edit', label: 'Веб-редактор', description: 'Использовать встроенный веб-редактор', value: 'editor' },
      { id: 'method_upload', icon: 'fa fa-upload', label: 'Загрузка файла', description: 'Загрузить файл с компьютера', value: 'upload' },
      { id: 'method_repository', icon: 'fab fa-github', label: 'Репозиторий', description: 'Использовать репозиторий Git', value: 'repository' },
      { id: 'method_template', icon: 'fa fa-rocket', label: 'Шаблон', description: 'Использовать шаблон Edge-стека', value: 'template' },
    ];

    this.selectedTemplate = null;

    this.onChangeFileContent = this.onChangeFileContent.bind(this);
    this.onChangeFile = this.onChangeFile.bind(this);
    this.onChangeTemplate = this.onChangeTemplate.bind(this);
    this.onChangeMethod = this.onChangeMethod.bind(this);
    this.onChangeFormValues = this.onChangeFormValues.bind(this);
  }

  onChangeFormValues(values) {
    this.formValues = values;
  }

  onChangeMethod(method) {
    this.state.Method = method;
    this.formValues.StackFileContent = '';
    this.selectedTemplate = null;
  }

  onChangeTemplate(template) {
    return this.$async(async () => {
      this.formValues.StackFileContent = '';
      try {
        const fileContent = await this.EdgeTemplateService.edgeTemplate(template);
        this.formValues.StackFileContent = fileContent;
      } catch (err) {
        this.Notifications.error('Ошибка', err, 'Не удалось получить шаблон');
      }
    });
  }

  onChangeFileContent(value) {
    this.formValues.StackFileContent = value;
    this.state.isEditorDirty = true;
  }

  onChangeFile(value) {
    return this.$async(async () => {
      this.formValues.StackFile = value;
    });
  }

  async $onInit() {
    return this.$async(async () => {
      try {
        const templates = await this.EdgeTemplateService.edgeTemplates();
        this.templates = templates.map((template) => ({ ...template, label: `${template.title} - ${template.description}` }));
      } catch (err) {
        this.Notifications.error('Ошибка', err, 'Не удалось получить шаблоны');
      }
    });
  }
}

export default DockerComposeFormController;
